module.exports = __webpack_public_path__ + "static/media/houndstooth_logo_white.7d13a3e1.png";